module.exports = __webpack_public_path__ + "media/images/athletes/3167-068c4ff56facee1e877934e290ab4c5c.png";